export default __webpack_public_path__ + "static/media/fire-protection.8cee37e7.png";